import { render, staticRenderFns } from "./CargoHandlingIcon.vue?vue&type=template&id=498a8011&"
import script from "./CargoHandlingIcon.vue?vue&type=script&lang=js&"
export * from "./CargoHandlingIcon.vue?vue&type=script&lang=js&"
import style0 from "./CargoHandlingIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports